module.exports = __webpack_public_path__ + "static/carlsbad-2-04a6a621aeee6782a34b9ca1f39df627.jpeg";